<template>
  <div class="page-login">
    <div class="pg-log-form">
      <div class="form-header">
        <img src="../../assets/images/logo.png" class="logo" alt="">
        <div>集運幫 (後臺管理)</div>
      </div>
      <div class="form-cont">
        <Form :label-width="80">
          <FormItem label="用戶名">
            <Input v-model="form.username" placeholder="請輸入用戶名" ref='username' @keyup.enter.native="onPassword"></Input>
          </FormItem>
          <FormItem label="密碼">
            <Input type="password" v-model="form.password" placeholder="請輸入密碼" ref='password'
                   @keyup.enter.native="onSubmit"></Input>
          </FormItem>
        </Form>
      </div>
      <div class="form-footer">
        <Button type="primary" long @click="handleLogin" v-if="!isLoading">登錄</Button>
        <Button type="primary" long :loading="isLoading" v-else>loading...</Button>
      </div>
    </div>
  </div>
</template>

<script>
import 'vant/lib/dialog/style';
import { Dialog } from 'vant';
export default {
  data() {
    return {
      isLoading: false,
      form: {
        username: '',
        password: ''
      },
      isShowModalDelete: false
    };
  },
  methods: {
    onPassword() {
      this.$refs.password.focus();
    },
    onSubmit() {
      this.handleLogin();
    },
    handleLogin() {
      const _this = this
      let form = this.form;
      if (form.username === '') {
        this.$Utils.showTipInfo('請輸入用户名');
        return;
      } else if (form.password === '') {
        this.$Utils.showTipInfo('請輸入密碼');
        return;
      }

      this.isLoading = true;

      this.$Rq.request({
        url: this.$Api.login,
        method: 'post',
        data: {
          phone: form.username,
          password: form.password
        }
      }).then((res) => {
        this.isLoading = false;

        if (res.code == 0) {
          this.$store.commit('setLogInfo', res.data);
          const ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            // this.isShowModalDelete = true
            Dialog.confirm({
              title: '警告',
              message:
                '当前为微信环境，是否跳入《认领件页面》',
            })
              .then(() => {
                _this.$router.push('claimConfirmation')
              })
              .catch(() => {
                _this.$router.push({path: '/home'});
              });
          } else {
            this.$router.push({path: '/home'});
          }
        } else {
          this.$Utils.showTipInfo(res.msg);
        }
      }).catch((err) => {
        this.isLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "Login.scss";
</style>
